import CRUDService from "../services/base/CRUDService";

export default class StockLevelService extends CRUDService {

  getBaseURL() {
    return 'ton/v1/stock-levels/';
  }

  async deleteStockLevelById(id) {
    return super.getHttpRequest().delete(`${this.getBaseURL()}${id}`)
  }

}



// WEBPACK FOOTER //
// ./src/stockLevel/StockLevelService.js